/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'

import TopBar from '../../components/TopBar';
import down from '../../assets/images/icondropdown.svg'
import closeIcon from '../../assets/images/close.svg'

import styles from './team.module.css'

import { getAllRoles, createRole, updateRole, deleteRole } from '../../api/team';

const NewRole = () => {
    const popupRef = useRef();
    const addRolePopupRef = useRef();
    const deleteRolePopupRef = useRef();

    const [selectedRole, setSelectedRole] = useState();
    const [showDeletePopup, setShowDeletePopup] = useState(false);

    const [roleList, setRoleList] = useState([]);
    const [showAddInput, setShowAddInput] = useState(false);
    const [newRoleName, setNewRoleName] = useState("");
    const [error, setError] = useState("");
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);

    // Permissions state
    const [permissions, setPermissions] = useState([]);

    const availableRoutes = [
        { id: 'dashboard', name: 'Dashboard', permissions: ['read', 'write'] },
        { id: 'pages', name: 'Pages', permissions: ['read', 'write'] },        
        { id: 'products', name: 'Products', permissions: ['read', 'write'] },
        { id: 'productsCategory', name: 'Products Category', permissions: ['read', 'write'], depened: 'products' },
        { id: 'productsBrand', name: 'Products Brand', permissions: ['read', 'write'], depened: 'products' },
        { id: 'productsReview', name: 'Products Review', permissions: ['read', 'write'], depened: 'products' },
        { id: 'productsImport', name: 'Products Import', permissions: ['read', 'write'], depened: 'products' },
        { id: 'orders', name: 'Orders', permissions: ['read', 'write'] },
        { id: 'coupons', name: 'Coupons', permissions: ['read', 'write'] },
        { id: 'customers', name: 'Customers', permissions: ['read', 'write'] },
        { id: 'subscribers', name: 'Subscribers', permissions: ['read', 'write'] },
        { id: 'media', name: 'Media', permissions: ['read', 'write'] },
        { id: 'appearance', name: 'Appearance', permissions: ['read', 'write'] },
        { id: 'menus', name: 'Menus', permissions: ['read', 'write'], depened: 'appearance' },
        { id: 'header', name: 'Header', permissions: ['read', 'write'], depened: 'appearance' },
        { id: 'footer', name: 'Footer', permissions: ['read', 'write'], depened: 'appearance' },
        { id: 'banner', name: 'Banner', permissions: ['read', 'write'], depened: 'appearance'},
        { id: 'mobileMenu', name: 'Mobile Menu', permissions: ['read', 'write']},
        { id: 'team', name: 'Team', permissions: ['read', 'write'] },
        { id: 'settings', name: 'Settings', permissions: ['read', 'write'] },
    ];

    // 🔁 OBJECT → ARRAY
    const normalizePermissions = (permissionObj = {}) => {
        return availableRoutes.map(route => ({
            routeId: route.id,
            read: !!permissionObj?.[route.id]?.read,
            write: !!permissionObj?.[route.id]?.write,
        }));
    };

    const loadRoles = async () => {
        try {
            const response = await getAllRoles();

            if (response?.data?.length > 0) {
                const roles = response?.data;
                const lastRole = roles[roles?.length - 1];

                setRoleList(roles);
                setSelectedRole(lastRole);
                setPermissions(
                    normalizePermissions(lastRole?.permissions)
                );
            }
        } catch (error) {
            console.log('Failed to load roles', error);
        }
    };


    useEffect(() => {
        loadRoles();
    }, []);

    useEffect(() => {
        if (!selectedRole) return;

        if (selectedRole) {
            const roleData = roleList?.find((item) => item?.roleId === selectedRole?.roleId)
            setPermissions(roleData?.permissions)
        } else {
            setPermissions(normalizePermissions(selectedRole?.permissions));
        }

    }, [selectedRole]);


    const handleSaveRoleToServer = async () => {
        if (!selectedRole?.roleId) return;

        try {
            setIsLoading(true);

            await updateRole(selectedRole.roleId, {
                role: selectedRole?.name,
                permissions: permissions,
            });
        } catch (error) {
            console.error('Failed to save role', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveRole = async () => {
        if (!newRoleName.trim()) {
            setError("Role name is required");
            return;
        }

        try {
            setIsAddLoading(true);

            const response = await createRole({
                role: newRoleName.trim(),
                permissions: availableRoutes?.map(route => ({
                    routeId: route?.id,
                    read: false,
                    write: false,
                })),
            });

            if (response) {
                setRoleList(prev => [response?.data, ...prev]);
                setSelectedRole(response?.data);
                setPermissions(response?.data?.permission || availableRoutes?.map(route => ({
                    routeId: route?.id,
                    read: false,
                    write: false,
                })));
            }

            setNewRoleName("");
            setError("");
            setShowAddInput(false);
        } catch (error) {
            console.log({ error })
            setError(error?.error?.message || "Failed to create role");
        } finally {
            setIsAddLoading(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setOpen(false);
            }
            if (addRolePopupRef.current && !addRolePopupRef.current.contains(event.target)) {
                setShowAddInput(false);
            }
            if (deleteRolePopupRef.current && !deleteRolePopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [])


    const handlePermissionChange = (routeId, permissionType, checked) => {
        setPermissions(prev => {
            let updated = [...prev];

            const setPermission = (id, value) => {
                const index = updated.findIndex(p => p.routeId === id);
                const permission = {
                    routeId: id,
                    read: value,
                    write: value,
                };

                if (index >= 0) {
                    updated[index] = permission;
                } else {
                    updated.push(permission);
                }
            };

            const clearPermission = (id) => {
                const index = updated.findIndex(p => p.routeId === id);
                if (index >= 0) {
                    updated[index] = { routeId: id, read: false, write: false };
                }
            };

            const route = availableRoutes.find(r => r.id === routeId);

            // ✅ If checked
            if (checked) {
                // Enable current route
                setPermission(routeId, true);

                // 🔗 Enable parent if dependency exists
                if (route?.depened) {
                    setPermission(route.depened, true);
                }
            } 
            // ❌ If unchecked
            else {
                clearPermission(routeId);

                // ⛔ Disable all children if parent unchecked
                availableRoutes.forEach(r => {
                    if (r.depened === routeId) {
                        clearPermission(r.id);
                    }
                });
            }

            return updated;
        });
    };


    const handleRoleSelect = (role) => {
        setSelectedRole(role);
        setOpen(false);
    };


    const confirmDelete = async () => {
        if (!selectedRole) return;

        try {
            setCancelLoading(true);
            await deleteRole([selectedRole?.roleId]);
            await loadRoles(); // Refresh the roles list
            setShowDeletePopup(false);
        } catch (error) {
            console.log('Failed to delete role', error);
            // Optionally set an error state here if needed
        } finally {
            setCancelLoading(false);
        }
    };

    return (
        <>
            <TopBar />
            <div className={styles.settingsMenuList}>
                <div className={styles.menuTop}>
                    <button className='add-btn' onClick={() => { setShowAddInput(true); setError(""); setNewRoleName("") }}>Add Role</button>

                    <div className='dropdown-wrapper' ref={popupRef}>
                        <div className='dropdown-header' onClick={() => setOpen(!open)}>
                            <span className='title'> {selectedRole?.role ? selectedRole?.role : "Select Role"}</span>
                            <span className={`arrow ${open ? "rotate" : ""}`}><img src={down} alt='down-icon'/></span>
                        </div>

                        {open && (
                            <div className='dropdown-list' >
                                {roleList?.length > 0 && roleList?.map((role, index) => (
                                    <div key={index} onClick={() => handleRoleSelect(role)} className='dropdown-item'>
                                        <span>{role?.role}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.settingsListWrap}>
                    <div className={styles.navLeftList}>
                        <p className={`${styles.settingsMenuBlockTitle} ${styles.titleBottom}`}>
                            Select permissions for the role
                        </p>

                        <div className={styles.navigationLeft}>
                            {availableRoutes?.map((route, index) => {
                                const routePermissions = permissions?.find(p => p?.routeId === route?.id) || {};
                                return (
                                    <div key={index} className={styles.navigationBlocks}>
                                        <p className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle}`}>
                                            {route.name} -
                                        </p>

                                        <div className={styles.settingsMenuPages}>
                                            {/* <div className={styles.settingsMenuItem}>
                                                <input
                                                    type="checkbox"
                                                    id={`read-${route?.id}`}
                                                    checked={routePermissions.read || false}
                                                    onChange={(e) => handlePermissionChange(route?.id, 'read', e?.target?.checked)}
                                                />
                                                <label htmlFor={`read-${route?.id}`}>
                                                    Read
                                                </label>
                                            </div> */}
                                            <div className={styles.settingsMenuItem}>
                                                <input
                                                    type="checkbox"
                                                    id={`write-${route?.id}`}
                                                    checked={routePermissions.write || false}
                                                    onChange={(e) => handlePermissionChange(route?.id, 'write', e?.target?.checked)}
                                                />
                                                <label htmlFor={`write-${route?.id}`}>
                                                    Allow
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className={styles.navigationRight}>
                        <p className={styles.settingsMenuBlockTitle}>Role permissions summary</p>

                        <div className={styles.navRightList}>
                            <div className={styles.menuSorter}>
                                {permissions?.length > 0 && permissions.map((permission, index) => {
                                    const route = availableRoutes.find(r => r.id === permission.routeId);
                                    if (!route) return null;

                                    return (
                                        <div key={index} className={styles.menuItemRow}>
                                            <div className={styles.menuItem}>
                                                <span className={styles.menuTitleFront}>
                                                    {route.name}
                                                </span>
                                                <div className={styles.permissionBadges}>
                                                    {permission?.read && <span className={styles.readBadge}>Read</span>}
                                                    {permission?.write && <span className={styles.writeBadge}>Write</span>}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                                {permissions?.length === 0 && (
                                    <div className={styles.noPermissions}>
                                        No permissions assigned to this role
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {selectedRole && (
                    <div className={styles.saveButtons}>
                        {(selectedRole.role !== 'Default' && selectedRole.role !== 'Sale Person') && (
                            <button
                                className={`${styles.deleteButton} ${cancelLoading ? styles.btnLoading : styles.button
                                    }`}
                                onClick={() => {
                                    setShowDeletePopup(true);
                                }}
                            >
                                {cancelLoading ? (
                                    <div className={styles.cancelLoader}>
                                        <div className={`${styles.ringLoader} ${styles.cancel}`}></div>
                                    </div>
                                ) : (
                                    "Delete"
                                )}
                            </button>
                        )}

                        <button
                            className={`${styles.saveButton} ${isLoading ? styles.btnLoading : styles.button
                                }`}
                            onClick={handleSaveRoleToServer}
                        >
                            {isLoading ? (
                                <div className='ringLoader'>
                                </div>
                            ) : (
                                "Save"
                            )}
                        </button>
                    </div>
                )}
            </div>

            {/* Add Role Popup */}
            {showAddInput && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user" ref={addRolePopupRef}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={closeIcon} onClick={() => setShowAddInput(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>Add Role</div>
                        <div className={styles.addMenuContent}>
                            <div>
                                <input
                                    type="text"
                                    value={newRoleName}
                                    onChange={(e) => { setNewRoleName(e.target.value); setError("") }}
                                    placeholder="Enter role name"
                                    className={styles.menuAddInput}
                                />

                                {error && (
                                    <p className='error-message'>{error}</p>
                                )}
                            </div>

                            <button
                                // className={styles.addBtn}
                                className={`${styles.addBtn} ${isAddLoading ? styles.btnLoading : styles.button
                                    }`}
                                onClick={handleSaveRole}
                            >
                                {
                                    isAddLoading ?
                                        <div className='ringLoader'></div> : 'Save'
                                }

                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* Delete Confirmation Popup */}
            {showDeletePopup && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box role-delete-popup" ref={deleteRolePopupRef}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={closeIcon} onClick={() => setShowDeletePopup(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>Delete Role</div>
                        <div className="popup-form">
                            <p>Are you sure you want to delete the role "{selectedRole?.role}"?</p>
                            <div className="popup-actions">
                                <button className="cancel-btn" onClick={() => setShowDeletePopup(false)}>Cancel</button>
                                <button className="save-btn" onClick={confirmDelete}>{cancelLoading ? <div className='ringLoader'></div> : 'Delete'}</button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default NewRole